import { connect } from 'react-redux';

import { pickAndSetLateralImage } from '../../actions/lateralImage';

import SplitContainer from './SplitContainer';

const _mapStateToProps = ({ frontend }) => ({
    lateralImage: frontend.lateralImage,
});

const _mapDispatchToProps = {
    onLoadComponent: pickAndSetLateralImage,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(SplitContainer);
